import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}

// jwtToken
const getJwtToken = () => {
  try {
    const raw = sessionStorage.getItem("clinic-application-jwt") || localStorage.getItem("clinic-application-jwt");
    if (!raw) return "";
    const userData = JSON.parse(raw);
    return userData?.token ? "Bearer " + String(userData.token) : "";
  } catch (err) {
    return "";
  }
};


export const postCustomFieldtoPatients = createAsyncThunk(
  "patients/postCustomField",
  async ({ patientId, fieldName, fieldValue, primary, secondary, tertiary, primarySub, secondarySub, tertiarySub, treatment, visitStatus, updatedByName }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${END_POINT}/customer/custom/${patientId}`, {
        fieldName: fieldName || 'custom',
        fieldValue: fieldValue !== undefined && fieldValue !== null ? fieldValue : '',
        primary: primary || '',
        secondary: secondary || '',
        tertiary: tertiary || '',
        primarySub: primarySub || '',
        secondarySub: secondarySub || '',
        tertiarySub: tertiarySub || '',
        treatment: treatment || '',
        visitStatus: visitStatus || '',
        updatedByName: updatedByName || ''
      }, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.response?.data || error.message || "Something went wrong");
    }
  }
);
